import { render, staticRenderFns } from "./RecoverPasswordView.vue?vue&type=template&id=b2bb0f1e&lang=pug&"
import script from "./RecoverPasswordView.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports